/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Top_Partners_TitleInputs */



/**
* | output |
* | --- |
* | "Top partners by AI cost" |
*
* @param {Partner_Dashboard_Top_Partners_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_top_partners_title = /** @type {((inputs?: Partner_Dashboard_Top_Partners_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Top_Partners_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Top-Partner nach KI-Kosten")
	return /** @type {LocalizedString} */ ("Top partners by AI cost")
});